export enum EServico {
  publicacaoMateria = 0,
  consulta = 1,
  ressarcimentoValores = 2,
  gratuidadePublicacao = 3
}
